function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from "react";
import { func, shape, bool, string } from "prop-types";
import injectSheet from "react-jss";
import cx from "classnames";
var styles = {
    bar: {
        width: 25,
        height: 3,
        margin: "4px 0",
        transition: "0.4s"
    },
    bar1: {
        extend: "bar",
        backgroundColor: function(props) {
            return props.color;
        }
    },
    bar2: {
        extend: "bar",
        backgroundColor: function(props) {
            return props.color;
        }
    },
    bar3: {
        extend: "bar",
        backgroundColor: function(props) {
            return props.color;
        }
    },
    container: {
        display: "inline-block",
        cursor: "pointer"
    },
    expanded: {
        "& $bar1": {
            transform: "rotate(-45deg) translate(-6px, 6px)"
        },
        "& $bar2": {
            opacity: 0
        },
        "& $bar3": {
            transform: "rotate(45deg) translate(-4px, -4px)"
        }
    }
};
export function Hamburger(param) {
    var className = param.className, classes = param.classes, isExpanded = param.isExpanded, onClick = param.onClick;
    return /*#__PURE__*/ React.createElement("div", {
        className: cx(classes.container, className, _defineProperty({}, classes.expanded, isExpanded)),
        onClick: onClick,
        role: "button",
        tabIndex: "0",
        "aria-pressed": "false"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes.bar1
    }), /*#__PURE__*/ React.createElement("div", {
        className: classes.bar2
    }), /*#__PURE__*/ React.createElement("div", {
        className: classes.bar3
    }));
}
Hamburger.propTypes = {
    className: string,
    classes: shape({}),
    isExpanded: bool,
    onClick: func
};
// Since we need to expose the default props to JSS
Hamburger.defaultProps = {
    color: "#000"
};
export default injectSheet(styles)(Hamburger);
